import { render, staticRenderFns } from "./_partnerMarketList.vue?vue&type=template&id=cda3bd70&scoped=true&lang=pug&"
import script from "./_partnerMarketList.vue?vue&type=script&lang=js&"
export * from "./_partnerMarketList.vue?vue&type=script&lang=js&"
import style0 from "./_partnerMarketList.vue?vue&type=style&index=0&id=cda3bd70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda3bd70",
  null
  
)

export default component.exports